import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-51bc7ee1")

_pushScopeId("data-v-51bc7ee1")
const _hoisted_1 = { class: "order-badge" }
const _hoisted_2 = { class: "subscription-box" }
const _hoisted_3 = { class: "subscription-number" }
const _hoisted_4 = {
  key: 0,
  class: "subscription-surprise"
}
const _hoisted_5 = {
  key: 1,
  class: "subscription-surprise"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 2,
  class: "total-price-wrapper"
}
const _hoisted_8 = {
  key: 2,
  class: "spin"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_toolbar = _resolveComponent("toolbar")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_image_loader = _resolveComponent("image-loader")
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_toolbar, {
        title: _ctx.$tr(_ctx.trMenu, 'orders'),
        backbutton: true
      }, null, 8, ["title"]),
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withId(() => [
          (_ctx.orders.length && !_ctx.loading)
            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.orders, (order, key) => {
                return (_openBlock(), _createBlock(_component_ion_list, {
                  key: key,
                  class: {'is-gift': order.isGift}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_item, { lines: "none" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withId(() => [
                            _createVNode("h2", null, [
                              _createVNode("b", null, _toDisplayString(order.number), 1)
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.filters.dateFormat(order.dateCreate, 'DD.MM.YYYY')), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode("small", _hoisted_1, _toDisplayString(order.status), 1)
                      ]),
                      _: 2
                    }, 1024),
                    (order.subscription)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$tr(_ctx.trOrder, 'subscriptionSend').replace('%groupName%', order.subscription.planGroupName ? '«' + order.subscription.planGroupName + '»' : '')), 1),
                          _createVNode("div", _hoisted_3, _toDisplayString(order.subscription.number), 1),
                          (!order.subscription.showShipmentContent)
                            ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.$tr(_ctx.trOrder, 'surprise')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (!order.canShowContents)
                        ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.$tr(_ctx.trOrder, 'orderHide')), 1))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(order.items, (item) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        key: item.id,
                        lines: "none",
                        onClick: ($event: any) => (_ctx.$root.navi('/product/' + item.product.id))
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_thumbnail, { class: "cart-image" }, {
                            default: _withId(() => [
                              _createVNode(_component_image_loader, {
                                "style-class": "img",
                                src: item.product.mainImage
                              }, null, 8, ["src"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_col, { size: "8" }, {
                            default: _withId(() => [
                              _createVNode("p", {
                                style: {"padding":"0","margin":"0"},
                                innerHTML: item.product.name
                              }, null, 8, ["innerHTML"]),
                              (item.isGift)
                                ? (_openBlock(), _createBlock(_component_ion_text, {
                                    key: 0,
                                    color: "gift"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode("small", null, [
                                        _createVNode(_component_ion_icon, { icon: _ctx.gift }, null, 8, ["icon"]),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$tr(_ctx.trOrder, 'gift')), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_col, {
                            size: "2",
                            style: {"text-align":"right"}
                          }, {
                            default: _withId(() => [
                              _createVNode("small", null, _toDisplayString(' x ' + item.quantity), 1),
                              _hoisted_6,
                              _createVNode("small", null, [
                                (!item.isGift && !order.isGift && !order.subscription)
                                  ? (_openBlock(), _createBlock("b", {
                                      key: 0,
                                      innerHTML: item.stringPrice
                                    }, null, 8, ["innerHTML"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128)),
                    (!order.isGift)
                      ? (_openBlock(), _createBlock("div", _hoisted_7, [
                          _createTextVNode(_toDisplayString(_ctx.$tr(_ctx.trOrder, 'total')) + "    ", 1),
                          _createVNode("span", {
                            class: "total-price",
                            innerHTML: order.stringTotal
                          }, null, 8, ["innerHTML"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_item, { lines: "none" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_button, {
                          size: "small",
                          slot: "end",
                          onClick: ($event: any) => (_ctx.goToSite(order.id)),
                          color: "shiawasedo"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.$tr(_ctx.trOrder, 'open')), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            : (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_ion_item, {
                  key: 1,
                  class: "ion-padding",
                  lines: "none"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tr(_ctx.trOrder, 'empty')), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode(_component_ion_spinner, { name: "circles" })
                ])),
          (!_ctx.allLoading)
            ? (_openBlock(), _createBlock(_component_ion_infinite_scroll, {
                key: 3,
                onIonInfinite: _cache[1] || (_cache[1] = ($event: any) => (_ctx.paginate($event))),
                threshold: "100px",
                id: "infinite-scroll",
                disabled: _ctx.isDisabled
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_infinite_scroll_content, { "loading-spinner": "circles" })
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})